export const REMIND_SIGNATURES_START = 'REMIND_SIGNATURES_START';
export const REMIND_SIGNATURES_SUCCESS = 'REMIND_SIGNATURES_SUCCESS';
export const REMIND_SIGNATURES_FAIL = 'REMIND_SIGNATURES_FAIL';

export type SignatureActionTypes =
  | typeof REMIND_SIGNATURES_START
  | typeof REMIND_SIGNATURES_SUCCESS
  | typeof REMIND_SIGNATURES_FAIL;
